import { useState } from "react";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import RFField from "../../../Form/RFField";
import RFForm from "../../../Form/RFForm";
import { useEditorContext } from "../../Wysiwyg";
import ToolbarItem from "../ToolbarItem";

const DEFAULT_HIGHLIGHT_COLOR = "#ffffff";

const ToolbarHighlight = () => {
  const { editor } = useEditorContext();

  const [modal, setModal] = useState(false);
  const [color, setColor] = useState(DEFAULT_HIGHLIGHT_COLOR);

  const currentHighlightColor = editor?.isActive("highlight")
    ? editor.getAttributes("highlight").color || DEFAULT_HIGHLIGHT_COLOR
    : "";

  const toggle = () => {
    setModal(!modal);
    setColor(currentHighlightColor || DEFAULT_HIGHLIGHT_COLOR);
  };

  const handleSubmit = () => {
    editor.chain().focus().setHighlight({ color }).run();
    toggle();
  };

  return (
    <>
      <ToolbarItem
        id={`color-toolbar-item`}
        tooltip={`Kiemelés`}
        active={false}
        onToggle={toggle}
        style={{ height: "28px" }}
        icon={
          <div style={{ position: "relative" }}>
            <i
              className="fa fa-highlighter"
              aria-hidden="true"
              style={{ marginBottom: 4 }}
            />
            <div
              style={{
                position: "absolute",
                bottom: 0,
                left: -4,
                right: -4,
                height: "3px",
                backgroundColor: currentHighlightColor,
              }}
            />
          </div>
        }
      />

      <Modal isOpen={modal} toggle={toggle} backdrop="static">
        <RFForm onSubmit={handleSubmit}>
          <ModalHeader toggle={toggle}>Kiemelés</ModalHeader>
          <ModalBody>
            <RFField
              id="color"
              name="color"
              type="color"
              label="Kiemelés színe"
              value={color}
              onChange={(e, v) => setColor(v)}
              required
            />
          </ModalBody>
          <ModalFooter>
            <Button color="primary">OK</Button>{" "}
            <Button color="secondary" onClick={toggle}>
              Mégsem
            </Button>
          </ModalFooter>
        </RFForm>
      </Modal>
    </>
  );
};

export default ToolbarHighlight;
